import React, { Component } from 'react';
import {
  FlatList,
  InteractionManager,
  Platform,
  StyleSheet,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';
import OrderHeader from '../item/OrderHeader';
import OrderItem from '../item/OrderItem';
import SearchInput from '../common/SearchInput';
import Empty from '../common/Empty';
import APIClient from '../utils/APIClient';
import UserManager from '../utils/UserManager';

class SellerOrderListScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    const {updateQuery, search} = params ? params : {};
    return {
      headerBackTitle: null,
      headerTitle: (
        <SearchInput
          placeholder='ID / Emai / số điện thoại khách hàng'
          onUpdateQuery={updateQuery}
          onSubmit={search}/>
      ),
    };
  };

  constructor (props) {
    super(props);

    this._query = '';
    this._page = -1;
    this._items = [];
    this.state = {
      refreshing: false,
      items: [],
      noitem: false,
      query: this._query,
    };
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
      this._sellerId = this.props.match.params.id;
    } else {
      this._sellerId = this.props.navigation.state.params.id;
    }

    InteractionManager.runAfterInteractions(() => {
      this._refreshData(true);
    });
  }

  componentWillUnmount () {
  }

  _updateQuery = (query) => {
    if (this._query === query) {
      return;
    }

    this._query = query;
    this.setState({
      query: query,
    });
    if (Platform.OS !== 'web') {
      this.props.navigation.setParams({
        query: query,
      });
    }
  };

  _search = () => {
    this._loading = false;
    this._page = 1;
    this._refreshData(true);
  };

  _refreshData = (refreshing) => {
    this._resetData(refreshing);
    this._loadData();
  };

  _resetData (refreshing) {
    this._loading = false;
    this._page = 1;
    this._items = [];
    this.setState({
      refreshing: refreshing,
      items: this._items,
      noitem: false,
    });
  }

  _loadData = async () => {
    if (this._loading || this._page <= 0) {
      return;
    }

    this._loading = true;

    const path = `/orders/seller/${this._sellerId}`;
    const params = {
      page: this._page,
      limit: 20,
    };
    const {response, error} = await APIClient.GET(path, params);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    let {items, noitem} = this.state;
    if (response && response.response) {
      const newItems = response.response;
      if (newItems.length > 0) {
        items = items.concat(newItems);
        this._page++;
        this.setState({
          items: items,
        });
      } else {
        this._page = -1;
      }
      noitem = items.length === 0;
    } else {
      noitem = _.isEmpty(items);
    }

    this._loading = false;
    this.setState({
      refreshing: false,
      noitem: noitem,
    });
  }

  _onRefresh = () => this._refreshData(true);

  _onEndReached = () => this._loadData();

  _renderItem = ({item, index}) => {
    return (
      <OrderItem
        simple={!UserManager.getInstance().isAdmin()}
        data={item}
        onClick={this._handleClickItem}/>
    );
  };

  _handleClickItem = (data) => {
    if (Platform.OS === 'web') {
      const path = '/order/' + data.id;
      this.props.history.push(path);
    } else {
      const {navigation} = this.props;
      navigation.navigate('Order', {
        id: data.id,
      });
    }
  };

  render () {
    const {refreshing, items, noitem} = this.state;
    return (
      <View
        style={styles.container}>
        {Platform.OS === 'web' && <SearchInput
          placeholder='ID / Emai / số điện thoại khách hàng'
          onUpdateQuery={this._updateQuery}
          onSubmit={this._search}/>}

        <OrderHeader
          simple={!UserManager.getInstance().isAdmin()}/>

        <FlatList
          refreshing={refreshing}
          extraData={this.state}
          data={items}
          onRefresh={this._onRefresh}
          onEndReached={this._onEndReached}
          onEndReachedThreshold={0.5}
          renderItem={this._renderItem}
          style={styles.list}/>

        {noitem && <Empty
          text='Không có đơn hàng, bấm để thử lại'
          onClick={() => this._refreshData(false)}
          style={styles.empty}/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(
  SellerOrderListScreen);



// WEBPACK FOOTER //
// ./src/seller/SellerOrderListScreen.js